<template>
  <section class="map-mod">
    <template v-if="mapInfo.length">
      <ul class="map-list-box">
        <li class="map-list-title">
          <dl class="map-info-dl clearfix">
            <dt class="mid">ID</dt>
            <dd class="name item">名称</dd>
            <dd class="version item">审核中版本号</dd>
            <dd class="test-number item">已发布版本号(测试区)</dd>
            <dd class="formal-number item">已发布版本号(正式区)</dd>
          </dl>
        </li>

        <li class="map-list-item" v-for="item in mapInfo">
          <dl class="map-info-dl clearfix">
            <dt class="mid">{{ item.MapId }}</dt>
            <!--地图名称-->
            <dd class="name item">
              <template v-if="item.PubInfo">
                <router-link :to="{ name: 'mapShowStatus', params: {mapId: item.MapId, stage: 'pub'} }">
                  {{ item.MapName }}
                </router-link>
              </template>

              <template v-else-if="item.ExaInfo">
                <router-link :to="{ name: 'mapShowStatus', params: {mapId: item.MapId, stage: 'exa'} }">
                  {{ item.MapName }}
                </router-link>
              </template>

              <template v-else-if="item.DevInfo">
                <span href="javascript: void(0)">{{ item.MapName }}</span>
                <!--<router-link :to="{ name: 'mapShowStatus', params: {mapId: item.MapId, stage: 'dev'} }">
                  {{ item.MapName }}
                </router-link>-->
              </template>

              <template v-else>
                {{ item.MapName }}
              </template>
            </dd>

            <!--审核区的版本信息开始-->
            <dd class="version item">
              <template v-if="item.DevInfo">
                <span class="ver-num">{{ item.DevInfo.MapVersion }}</span>

                <span v-if="item.DevInfo.Status === 0">未提交</span>

                <router-link v-if="item.DevInfo.Status === 1" :to="{ name: 'devMapinspect', params: {mapId: item.MapId, stage: 'dev'} }">
                  <span class="text base-examine">提交审核</span>
                </router-link>

                <router-link v-if="item.DevInfo.Status === 2" :to="{ name: 'toExamine', params: {mapId: item.MapId, stage: 'dev'} }">
                  <span class="text base-examine">审核中</span>
                </router-link>

                <router-link class="examine-rewrite" v-if="item.DevInfo.Status === 3" :to="{ name: 'mapInfoImperfect', params: {mapId: item.MapId, stage: 'dev'} }">
                  <i class="icon icon-examine-rewrite"></i>
                  <span class="text">请重新填写</span>
                </router-link>

                <router-link class="examine-fail" v-if="item.DevInfo.Status === 4" :to="{ name: 'examineFail', params: {mapId: item.MapId, stage: 'dev'} }">
                  <i class="icon icon-examine-fail"></i>
                  <span class="text">审核失败</span>
                </router-link>

                <span v-if="item.DevInfo.Status === 5">已删除</span>

                <span class="examine-success" v-if="item.DevInfo.Status === 6">
                  <i class="icon icon-examine-success"></i>
                  <span class="text">审核通过</span>
                </span>
              </template>

              <template v-else>
                <span>无</span>
              </template>
            </dd>
            <!--审核区的版本信息结束-->

            <!--测试区的版本信息开始-->
            <dd class="test-number item">
              <template v-if="item.ExaInfo">
                <span class="ver-num">{{ item.ExaInfo.MapVersion }}</span>

                <span v-if="item.ExaInfo.Status === 0">未提交</span>

                <router-link v-if="item.ExaInfo.Status === 1" :to="{ name: 'devMapinspect', params: {mapId: item.MapId, stage: 'exa'} }">
                  <!--<span class="text base-examine">提交审核</span>-->
                </router-link>

                <router-link v-if="item.ExaInfo.Status === 2" :to="{ name: 'toExamine', params: {mapId: item.MapId, stage: 'exa'} }">
                  <span class="text base-examine">审核中</span>
                </router-link>

                <router-link class="examine-rewrite" v-if="item.ExaInfo.Status === 3" :to="{ name: 'mapInfoImperfect', params: {mapId: item.MapId, stage: 'exa'} }">
                  <i class="icon icon-examine-rewrite"></i>
                  <span class="text">请重新填写</span>
                </router-link>

                <router-link class="examine-fail" v-if="item.ExaInfo.Status === 4" :to="{ name: 'examineFail', params: {mapId: item.MapId, stage: 'exa'} }">
                  <i class="icon icon-examine-fail"></i>
                  <span class="text">审核失败</span>
                </router-link>

                <span v-if="item.ExaInfo.Status === 5">已删除</span>

                <span class="examine-success" v-if="item.ExaInfo.Status === 6">
                  <i class="icon icon-examine-success"></i>
                  <span class="text">审核通过</span>
                </span>
              </template>

              <template v-else>
                <span>无</span>
              </template>
            </dd>
            <!--测试区的版本信息结束-->

            <!--正式区的版本信息开始-->
            <dd class="formal-number item">
              <!--<template v-if="item.MapVersion">
                <span class="ver-num">{{ item.PubInfo.MapVersion }}</span>

                <span v-if="item.PubInfo.Status === 0">未提交</span>

                <router-link v-if="item.PubInfo.Status === 1" :to="{ name: 'devMapinspect', params: {mapId: item.MapId, stage: 'pub'} }">
                  <span class="text base-examine">提交审核</span>
                </router-link>

                <router-link v-if="item.PubInfo.Status === 2" :to="{ name: 'toExamine', params: {mapId: item.MapId, stage: 'pub'} }">
                  <span class="text base-examine">审核中</span>
                </router-link>

                <router-link class="examine-rewrite" v-if="item.PubInfo.Status === 3" :to="{ name: 'mapInfoImperfect', params: {mapId: item.MapId, stage: 'pub'} }">
                  <i class="icon icon-examine-rewrite"></i>
                  <span class="text">请重新填写</span>
                </router-link>

                <router-link class="examine-fail" v-if="item.PubInfo.Status === 4" :to="{ name: 'examineFail', params: {mapId: item.MapId, stage: 'pub'} }">
                  <i class="icon icon-examine-fail"></i>
                  <span class="text">审核失败</span>
                </router-link>

                <span v-if="item.PubInfo.Status === 5">已删除</span>

                <span class="examine-success" v-if="item.PubInfo.Status === 6">
                  <i class="icon icon-examine-success"></i>
                  <span class="text">审核通过</span>
                </span>
              </template>

              <template v-else>
                <span>无</span>
              </template>-->
              <span>无</span>
            </dd>
            <!--正式区的版本信息结束-->
          </dl>
        </li>

        <!--<li class="map-list-item">
		  <dl class="map-info-dl clearfix">
			<dt class="mid">1</dt>
			<dd class="name">吃鸡</dd>
			<dd class="version">无</dd>
			<dd class="test-number">无</dd>
			<dd class="formal-number">无</dd>
		  </dl>
		</li>

		<li class="map-list-item">
		  <dl class="map-info-dl clearfix">
			<dt class="mid">2</dt>
			<dd class="name">贪吃蛇</dd>
			<dd class="version">
			  <span>1.1.0</span>
			  <a href="javascript: void(0)">
                <span class="text base-examine">提交审核</span>
              </a>
			</dd>
			<dd class="test-number">无</dd>
			<dd class="formal-number">无</dd>
		  </dl>
		</li>

		<li class="map-list-item">
		  <dl class="map-info-dl clearfix">
			<dt class="mid">3</dt>
			<dd class="name">球球大作战</dd>
			<dd class="version">
			  <span>1.1.0</span>
			  <a href="javascript: void(0)">
                <span class="text base-examine">审核中</span>
              </a>
			</dd>
			<dd class="test-number">无</dd>
			<dd class="formal-number">无</dd>
		  </dl>
		</li>

		<li class="map-list-item">
		  <dl class="map-info-dl clearfix">
			<dt class="mid">4</dt>
			<dd class="name">飞机大战</dd>
			<dd class="version">
			  <span class="ver-num">1.1.0</span>
			  <a class="examine-rewrite" href="javascript: void(0)">
                <i class="icon icon-examine-rewrite"></i>
                <span class="text">请重新填写</span>
              </a>
			</dd>
			<dd class="test-number">无</dd>
			<dd class="formal-number">无</dd>
		  </dl>
		</li>

        <li class="map-list-item">
          <dl class="map-info-dl clearfix">
            <dt class="mid">5</dt>
            <dd class="name">跑跑卡丁车</dd>
            <dd class="version">
              <span class="ver-num">1.1.0</span>
              <a class="examine-fail" href="javascript: void(0)">
                <i class="icon icon-examine-fail"></i>
                <span class="text">审核失败</span>
              </a>
            </dd>
            <dd class="test-number">无</dd>
            <dd class="formal-number">无</dd>
          </dl>
        </li>

		<li class="map-list-item">
		  <dl class="map-info-dl clearfix">
			<dt class="mid">6</dt>
			<dd class="name">极品飞车</dd>
			<dd class="version">
			  <span>1.1.0</span>
			  <span class="examine-success">
                <i class="icon icon-examine-success"></i>
                <span class="text">审核通过</span>
              </span>
			</dd>
			<dd class="test-number">
			  <span>1.1.0</span>
              <span class="text base-examine">提交审核</span>
			</dd>
			<dd class="formal-number">无</dd>
		  </dl>
		</li>

		<li class="map-list-item">
		  <dl class="map-info-dl clearfix">
			<dt class="mid">7</dt>
			<dd class="name">斗地主</dd>
			<dd class="version">
			  <span>1.1.0</span>
			  <a href="javascript: void(0)">
                <span class="examine-success">
                  <i class="icon icon-examine-success"></i>
                  <span class="text">审核通过</span>
                </span>
              </a>
			</dd>
			<dd class="test-number">
			  <span>1.1.0</span>
			  <a href="javascript: void(0)">
                <span class="text base-examine">审核中</span>
              </a>
			</dd>
			<dd class="formal-number">无</dd>
		  </dl>
		</li>

		<li class="map-list-item">
		  <dl class="map-info-dl clearfix">
			<dt class="mid">8</dt>
			<dd class="name">三国杀</dd>
			<dd class="version">
			  <span>1.1.0</span>
              <span class="examine-success">
                <i class="icon icon-examine-success"></i>
                <span class="text">审核通过</span>
              </span>
			</dd>
			<dd class="test-number">
			  <span>1.1.0</span>
              <a class="examine-rewrite" href="javascript: void(0)">
                <i class="icon icon-examine-rewrite"></i>
                <span class="text">请重新填写</span>
              </a>
			</dd>
			<dd class="formal-number">无</dd>
		  </dl>
		</li>

		<li class="map-list-item">
		  <dl class="map-info-dl clearfix">
			<dt class="mid">9</dt>
			<dd class="name">狼人杀</dd>
			<dd class="version">
			  <span>1.1.0</span>
			  <span class="examine-success">
                <i class="icon icon-examine-success"></i>
                <span class="text">审核通过</span>
              </span>
			</dd>
			<dd class="test-number">
			  <span>1.1.0</span>
              <a class="examine-fail" href="javascript: void(0)">
                <i class="icon icon-examine-fail"></i>
                <span class="text">审核失败</span>
              </a>
			</dd>
			<dd class="formal-number">无</dd>
		  </dl>
		</li>

		<li class="map-list-item">
		  <dl class="map-info-dl clearfix">
			<dt class="mid">10</dt>
			<dd class="name">迷你世界</dd>
			<dd class="version">
			  <span>1.1.0</span>
			  <span class="examine-success">
                <i class="icon icon-examine-success"></i>
                <span class="text">审核通过</span>
              </span>
			</dd>
			<dd class="test-number">
			  <span>1.1.0</span>
			  <span class="examine-success">
                <i class="icon icon-examine-success"></i>
                <span class="text">审核通过</span>
              </span>
			</dd>
			<dd class="formal-number">1.1.0</dd>
		  </dl>
		</li>-->
      </ul>
    </template>

    <template v-else>
      <p class="no-map-desc">
        您还没有地图MOD，地图MOD通过《创造与魔法》开发插件制作，上传后在这里进行测试区的线上操作，玩家就可以玩到你的呢地图MOD了
        <router-link class="server-manage-btn" to="/downloadPlugin" target="_blank">下载插件</router-link>
      </p>
    </template>
  </section>
</template>

<script type="text/ecmascript-6">
  export default {
    // 我的地图MOD
    name: 'mapMod',
    props: {
      mapInfo: ''
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "mapMod.styl";
</style>



// WEBPACK FOOTER //
// src/views/mapMod/mapMod.vue